import '@fancyapps/fancybox'
import { Tabs, Accordion, Scrollbar, Mobile, Popup, Form_CoreInit } from './core'
import Header from './modules/header'
import Navigator from './modules/navigator'
import './plugins/municipalite'
import './plugins/tabs'
import './plugins/scroll-to-anchor'
import './plugins/load-more-posts'
import './plugins/filter-documents'
import './plugins/post-share'
import './plugins/form'

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    municipalitiesNavigator: undefined,
  }

  /* Header */
  Header.init()

  /* Tabs */
  Tabs.init()

  /* Accordions */
  Accordion.init()

  /* Popup */
  Popup.init()

  /* Forms */
  Form_CoreInit([
    {
      classSelector: 'builder-form--candidatures',
      formOptions: {
        floating_labels: true
      }
    }
  ])

  /* Municipalités */
  $.mlmi.municipalitiesNavigator = Navigator.init({
    singleClass: 'single-municipality',
    closeButtonURL: mrcavignon_l10n.HOME_URL,
    navigatorPageLoad: function(current) {
      setTimeout(function(){current.Municipalite() }, 100)
    },
    navigationOptions: {
      selectors: {
        links: '.card-municipality, .card-municipality__cta, .navigator__nav--municipality a:not(.navigator__btn-close), .target-municipalite',
      },
    },
  })

  /* Tabs Menu */
  $('.tabs__list').each(function() {
    $(this).slideSelectorMenu()
  })

  $('.heading-underline').each(function( index ) {
    $(this).wrapInner("<span></span>")
  })

  $('.submenu-row__links__item a, a.btn-anchor').each(function() {
    $(this).scrollToAnchor()
  })

  $('.js-filter-documents').each(function() {
    $(this).filterDocuments('.js-filter-documents-results', '.js-filter-documents-button')
  })

  /* make videos look like images */
  $('.video-loop').each(function() {
    let self = $(this)
    let video = $(this).find('video')
    if (video.data('loaded')) {
      setTimeout(function() {
        picture(video.get(0))
        video.get(0).play()
      }, 60)
    } else {
      video.on('canplaythrough', function() {
        picture(video.get(0))
        video.get(0).play()
      })
    }
  })

  /* Back to top */
  $('.back-to-top').on('click', function() {
    $('html, body').scrollTo(0, 350, 4, 'easeInOutQuart')
  })

  /* Scroll events */
  const scrollEvents = $(window).ScrollEvents()
  let scrolledDown = false,
  topArrow = $('.back-to-top').BlockElement()
  scrollEvents.add(function(top) {
    if (!scrolledDown && top > $(window).height() / 2) {
      scrolledDown = true
      topArrow.addModifier('visible')
      $('body').addClass('--scroll-top-visible')
    } else if (scrolledDown && top < $(window).height() / 2) {
      scrolledDown = false
      topArrow.removeModifier('visible')
      $('body').removeClass('--scroll-top-visible')
    }
  })

  /* Fade-in elements */
  $('.fade-in, .slide-in').each(function() {
    $(this).FadeIn()
  })

  /* Fixed content */
  $('.post-share').FixedContent({
    container: $('.post-share').parent(),
    topBlocker: null,
    limitFromTop: 30,
    mobile: true,
  })

  /* Sharing */
  $('.post-share').each(function() {
    $(this).PostShare()
  })

  /* Copy page URL */
  $('.post-share__action--copy-link').on('click', function() {
    let self = $(this)
    self.find('textarea').val(window.location.href).focus().select()
    document.execCommand("Copy")
    self.find('span').addClass('visible').text('Lien copié !')
    setTimeout(function() {
      self.find('span').removeClass('visible')
    }, 3200)
  })

  /* Calendars */
  $('.add-to-calendar').click(function() {
    if ($(this).hasClass('--open')) {
      $(this).removeClass('--open')
    } else {
      $('.add-to-calendar').removeClass('--open')
      $(this).addClass('--open')
    }
  })

  /* Forms */
  $('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })

  $('.builder-form').each(function() {
    $(this).BuilderForm()

  })

  $(".fancybox").fancybox({
    afterShow :function() {
      $('.fancybox-button--zoom').click()
    }
  })

  /* Load more posts */
  $('.js-load-more-posts').each(function() {
    $(this).loadMorePosts()
  })

  /* Make all news card the same height */
  $('.carousel .grid--postitem__news').css('height', $('.carousel .grid--postitem__news').outerHeight() + 'px')
  $( window ).resize(function() {
    $('.carousel .grid--postitem__news').css('height', 'auto')
    $('.carousel .grid--postitem__news').css('height', $('.carousel .grid--postitem__news').outerHeight() + 'px')
  })
})
